// PACKAGES
import React, { useReducer } from 'react'
import PropTypes from 'prop-types'
import { createContext } from 'use-context-selector'

export const PostingContext = createContext()

export const PostingProvider = ({ children, initialState = {} }) => {
  const reducer = (state, action) => {
    return { ...state, [action.id]: action.value }
  }

  const value = useReducer(reducer, initialState)

  return (
    <PostingContext.Provider value={value}>
      {children}
    </PostingContext.Provider>
  )
}

PostingProvider.propTypes = {
  children: PropTypes.any,
  initialState: PropTypes.object
}
